// logo
import logo from 'assets/images/logo2.png';

// ==============================|| LOGO SVG ||============================== //

const Logo = ({ width }) => <img src={logo} alt="SSB Digital" width={width ? width - width / 2 + 5 : 20} />;
// const Logo = ({ width }) => <img src={logo} alt="E-Sanrakshan" width={width ? width : 20} />;

export default Logo;
